import * as React from "react";
const SvgInfo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 9, y: 9, style: {
  fill: "rgba(255, 255, 255, 1)"
}, width: 2, height: 6 }), /* @__PURE__ */ React.createElement("rect", { x: 9, y: 5, style: {
  fill: "rgba(255, 255, 255, 1)"
}, width: 2, height: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 9, y: 9, style: {
  fill: "rgba(68, 93, 86, 0.3)"
}, width: 2, height: 6 }), /* @__PURE__ */ React.createElement("rect", { x: 9, y: 5, style: {
  fill: "rgba(68, 93, 86, 0.3)"
}, width: 2, height: 2 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "rgba(255, 255, 255, 1)"
}, d: "M10,0.7c-5.1,0-9.3,4.1-9.3,9.3s4.1,9.3,9.3,9.3s9.3-4.1,9.3-9.3S15.1,0.7,10,0.7z M10,18     c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "rgba(68, 93, 86, 0.5)"
}, d: "M10,0.7c-5.1,0-9.3,4.1-9.3,9.3s4.1,9.3,9.3,9.3s9.3-4.1,9.3-9.3S15.1,0.7,10,0.7z M10,18     c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z" })));
export default SvgInfo;
